function getDataLayer(): Record<string, unknown>[] | undefined {
  if (typeof window === 'undefined') return undefined
  return (window as { dataLayer?: Record<string, unknown>[] }).dataLayer
}

export function pushPageViewToDataLayer(pathname: string): void {
  const dataLayer = getDataLayer()
  if (!dataLayer) return

  dataLayer.push({
    event: 'page_view',
    page_path: pathname,
    page_title: typeof document !== 'undefined' ? document.title : undefined,
    page_location: typeof window !== 'undefined' ? window.location.href : undefined,
  } as unknown as Record<string, unknown>)
}
